import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { CommonList } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-lists-verification',
  templateUrl: 'cerfa-lists-verification.component.html',
  styleUrls: ['./cerfa-lists-verification.component.less', '../../../shared/common.less'],
})

export class CerfaListsVerificationComponent implements OnInit {
  @Input() commonLists: CommonList[];
  @Input() isValidated: boolean = false;
  @Output() commonListsChange = new EventEmitter<CommonList[]>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();
  isExpanded: boolean = true;
  needPap: boolean = undefined;

  constructor() { }

  onCommonListsChange() {
    this.commonListsChange.emit(this.commonLists);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  trackByIndex(index: number): number {
    return index;
  }

  onEdit() {
    this.editRequested.emit();
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }


  ngOnInit(): void {
  }
}
